import React from 'react';
import './KeyTakeaways.scss';

interface IKeyTakeaways {
    title: string;
    takeaways: string[];
}

export const KeyTakeaways = ({
    inputs: { title, takeaways },
}: {
    inputs: IKeyTakeaways;
}) => {
    if (!takeaways?.length) return;
    return (
        <section className="key-takeaways">
            <div className="key-takeaways__content">
                <h2 className="key-takeaways__title">{title}</h2>
                <ul className="key-takeaways__list">
                    {takeaways.map((takeaway) => (
                        <li key={takeaway} className="key-takeaways__item">
                            {takeaway}
                        </li>
                    ))}
                </ul>
            </div>
        </section>
    );
};
